import { Alert, Box, Tabs, createStyles, rem } from "@mantine/core";

import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import BusinessProfile from "./BusinessProfile";
import MyProfile from "./MyProfie";
import Upgrade from "./Upgrade";

import { IconInfoCircle } from "@tabler/icons-react";
import { isSignatureActivated, isSubscriptionExpired } from "../../../utils";
import ChangeMethod from "./ChangeMethod";
import { TrackPageView } from "../../../config/mixpanelConfig";
import AppNavbar from "../../../components/AppNavbar/AppNavbar";
import { SkaiCreadits } from "./SkaiCredits";
import MySignature from "./MySignature";
import Security from "./Security";
import ComplianceTab from "./ComplianceTab";
import { getAllSkypointProvider } from "../../../services/skypointProvider";
import { getAllPatients } from "../../../services/patient";
import Payment from "./Payment";

const useStyles = createStyles((theme) => ({
  "& .mantine-Container-root": {
    paddingLeft: "0!important",
    paddingRight: "0!important",
  },
  wrapper: {
    display: "flex",
  },
  content: {
    display: "flex",
    width: "100%",
    flexDirection: "column",
    background: "#F5F5F5",
  },
  tabs: {
    marginTop: 50,
    // background: 'blue',
    fontFamily: "Inter",
    marginLeft: 10,
    marginRight: 10,
    "@media (max-width: 768px)": {
      marginTop: 16,
      marginLeft: 0,
      marginRight: 0,
    },
  },
  tab_list: {
    background: "#fff",
    // height: "100px",
    padding: "10px 20px 0px",
    borderRadius: "10px",
    display: "flex",
    alignItems: "center",
    justifyContent: "start",
    flexWrap: "nowrap",
    ".mantine-Tabs-tab": {
      padding: "1.625rem 1rem",
    },
    "@media (max-width: 80em)": {
      overflowX: "auto",
      padding: "0px 10px",
    },
    "@media (max-width: 60em)": {
      padding: "0px 5px",
    },
    "@media (max-width: 768px)": {
      padding: "0px",
      borderRadius: "8px",
    },
  },
  tabPanel: {
    height: "60vh",
    "@media (max-width: 600px)": {
      height: "100dvh",
    },
  },
  tab: {
    // background: 'red',
    color: "979797",
    fontFamily: "Inter",
    fontSize: "14px",
    fontWeight: 500,
    paddingLeft: 30,
    paddingRight: 30,
    whiteSpace: "nowrap",
    "&:hover": {
      color: "#000",
      background: "transparent",
    },
    "&.mantine-Tab-active": {
      color: "#000",
    },
    "@media (max-width: 80em)": {
      fontSize: "12px",
      margin: "0 10px",
      paddingLeft: 0,
      paddingRight: 0,
    },
    "@media (max-width: 60em)": {
      fontSize: "10px",
      margin: "0 5px",
      paddingLeft: 0,
      paddingRight: 0,
    },
    "@media (max-width: 768px)": {
      fontSize: "12px",
      paddingLeft: 10,
      paddingRight: 10,
      margin: "0",
    },
  },
  mymodal: {
    width: 818,
    "& .mantine-Modal-inner": {
      padding: "0px !important",
    },
  },
  mwd: {
    width: "100%",
  },

  alertBox: {
    width: "100%",
    marginTop: "50px",
  },
}));
const Setting = () => {
  const { search, state } = useLocation();
  const queryParams = new URLSearchParams(search);
  const [currentTab, setCurrentTab] = useState("myprofile");
  const [defaultTab, setDefaultTab] = useState("myprofile");
  const selectedTab = queryParams.get("selectedTab");
  const { classes } = useStyles();
  const { profile } = useSelector((state) => state?.profile);

  useEffect(() => {
    if (state?.selectedTab) {
      setCurrentTab(state?.selectedTab);
    }
  }, [state?.selectedTab]);

  // useEffect(() => {
  //   if (selectedTab === "upgrade") {
  //     setDefaultTab("upgrade");
  //   }
  // }, [selectedTab]);
  useEffect(() => {
    if (selectedTab === "upgrade") {
      setCurrentTab("upgrade");
      setDefaultTab("upgrade");
    } else if (selectedTab === "my-signature") {
      setCurrentTab("my-signature");
      setDefaultTab("my-signature");
    } else if (selectedTab === "security") {
      setCurrentTab(selectedTab);
      setDefaultTab(selectedTab);
    } else if (selectedTab) {
      setCurrentTab(selectedTab);
      setDefaultTab(selectedTab);
    }
  }, [selectedTab]);
  useEffect(() => {
    getAllPatients(1, true, true);
    TrackPageView("Setting");
  }, []);

  return (
    <Box className={classes.content}>
      <AppNavbar title={"Settings"} profile={profile} />
      <Box px={{ base: 8, sm: 20 }}>
        <Tabs
          className={classes.tabs}
          defaultValue={selectedTab === "upgrade" ? "upgrade" : defaultTab}
          value={currentTab}
          onTabChange={(value) => setCurrentTab(value)}
          keepMounted={false}
        >
          <Tabs.List className={classes.tab_list}>
            <Tabs.Tab
              className={classes.tab}
              value="myprofile"
              color="gray"
              c={"#979797"}
            >
              My Profile
            </Tabs.Tab>
            {profile?.user?.type == "staff" ? null : (
              <Tabs.Tab
                className={classes.tab}
                c={"#979797"}
                value="business"
                color="gray"
              >
                Business Profile
              </Tabs.Tab>
            )}
            {profile?.user?.type == "staff" ? null : (
              <Tabs.Tab
                className={classes.tab}
                c={"#979797"}
                value="upgrade"
                color="gray"
              >
                Payment
              </Tabs.Tab>
            )}
            {/* {profile?.user?.type == "staff" ? null : (
              <Tabs.Tab
                className={classes.tab}
                value="method"
                c={"#979797"}
                color="gray"
              >
                Connected Accounts
              </Tabs.Tab>
            )} */}
            <Tabs.Tab
              className={classes.tab}
              c={"#979797"}
              value="security"
              color="gray"
            >
              Security
            </Tabs.Tab>
            <Tabs.Tab
              className={classes.tab}
              c={"#979797"}
              value="my-signature"
              color="gray"
            >
              My Signature
            </Tabs.Tab>
            {profile?.user?.type == "staff" ? null : (
              <Tabs.Tab
                className={classes.tab}
                c={"#979797"}
                value="skai-credits"
                color="gray"
              >
                Skai Credits
              </Tabs.Tab>
            )}
            {profile?.user?.type == "staff" ? null : (
              <Tabs.Tab
                className={classes.tab}
                c={"#979797"}
                value="compliance"
                color="gray"
                data-tour="settings-compliance-tab"
              >
                Command Center
              </Tabs.Tab>
            )}
          </Tabs.List>

          {isSubscriptionExpired() && (
            <div className={classes.alertBox}>
              <Alert
                color="red"
                title="Expired"
                variant="light"
                icon={<IconInfoCircle />}
              >
                Your subscription is expired.
              </Alert>
            </div>
          )}

          {profile?.signature?.length === 0 && (
            <div className={classes.alertBox}>
              <Alert
                color="red"
                title="Signature Not Activated"
                variant="light"
                icon={<IconInfoCircle />}
              >
                Your signature is not activated. Please create signature to
                continue
              </Alert>
            </div>
          )}

          <Tabs.Panel value="myprofile">
            <MyProfile />
          </Tabs.Panel>
          {profile?.user?.type !== "staff" && (
            <>
              <Tabs.Panel value="business">
                <BusinessProfile />
              </Tabs.Panel>
              <Tabs.Panel value="upgrade">
                <Payment currentTab={currentTab} />
              </Tabs.Panel>
              {/* <Tabs.Panel value="method" className={classes.tabPanel}>
                <ChangeMethod />
              </Tabs.Panel> */}
              <Tabs.Panel value="skai-credits">
                <SkaiCreadits />
              </Tabs.Panel>
            </>
          )}
          <Tabs.Panel value="my-signature">
            <MySignature />
          </Tabs.Panel>
          <Tabs.Panel value="security">
            <Security/>
          </Tabs.Panel>
          {profile?.user?.type !== "staff" && (
            <Tabs.Panel value="compliance">
              <ComplianceTab />
            </Tabs.Panel>
          )}
        </Tabs>
      </Box>
    </Box>
  );
};

export default Setting;
